import { get } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getCurrency } from "modules/portfolio-root/selectors/portfolios"
import { getMenuItems } from "./selectors"
import { getCurrentFactors, getTotalRow, getCategories, getSelectedFactorCategory } from "./selectors/data"
import { MODEL_METADATA_QUERY } from "resources/models"

import "./styles.scss"

export default createModule({
  view,
  required: ["accountId", "modelId", "portfolioId"],
  data: [{
    intradayChannel: ({ accountId, portfolioId }) => `${accountId}_${portfolioId}`,
    resource: "intradayRiskFactors",
    url: ({ modelId, date, portfolio, segment }) => {
      return ({
        id: `intradayRiskFactors-${modelId}${portfolio}${date}${JSON.stringify(segment)}`,
        query: `query ($modelId: String!, $portfolio: String!, $on: Date!, $segment: Segment, $horizon: PositiveInt!, $confidence: Float!) {
          model(id: $modelId) {
            intradaySimulation(positionSet: {type: PORTFOLIO, id: $portfolio, segment: $segment}, on: $on) {
              risk{
                total
                attribution{
                  summary{
                    factors
                    specific
                  }
                  factors{
                    id
                    value
                  }
                }
              }
              valueAtRisk(tradingDaysHorizon: $horizon, confidence: $confidence){
                total
                attribution{
                  summary {
                    factors
                    specific
                  }
                  factors {
                    id
                    value
                  }
                }
              }
              exposure {
                factors {
                  id
                  currencyExposure
                }
              }
            }
          }
        }`,
        variables: {
          on: date,
          modelId,
          portfolio,
          segment,
          horizon: 252,
          confidence: 84,
        },
      })
    },
  },
  MODEL_METADATA_QUERY,
  ],
  actions: {
    ...Creators,
  },
  mapStateToProps: (state, props) => ({
    ...get(state, "modules.intradayRiskFactors"),
    selectedFactorCategory: getSelectedFactorCategory(state, props),
    menuItems: getMenuItems(state, props),
    categories: getCategories(state, props),
    factors: getCurrentFactors(state, props),
    totalRow: getTotalRow(state, props),
    currency: getCurrency(state),
  }),
})
